import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=f5f35b56&scoped=true&"
import script from "./MaterialList.vue?vue&type=script&lang=js&"
export * from "./MaterialList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialList.vue?vue&type=style&index=0&id=f5f35b56&lang=scss&scoped=true&"
import style1 from "./MaterialList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f35b56",
  null
  
)

export default component.exports